<template>
  <span v-resize="checkMobile">
    <loading :active.sync="isLoading" :is-full-page="true" color="#1976d2"
      :background-color="$vuetify.theme.dark ? '#000' : ''"></loading>
    <v-card v-if="
      $store.getters.getMainCompany &&
      $store.getters.getMainCompany.payer_state != 3
    " data-testid="search-free-page">
      <v-card-title id="registration-step-48" style="padding-bottom: 0px !important">
        <v-flex>
          <h2 v-if="!isMobile">{{ $t("custom.search_free") }}</h2>
          <h4 v-else>{{ $t("custom.search_free") }}</h4>
          <h4 v-if="showDaysSize" class="subtitle-1">{{ calculateDaysSize() }}</h4>
        </v-flex>
      </v-card-title>
      <v-card-text>
        <!-- Даты, фильтры и порядок — одной строкой в общей плашке, как командная
             шапка парка. Управление появляется после первого поиска: до дат
             фильтровать и сортировать нечего, а в приглашении оно спорило бы за
             внимание с самим приглашением. -->
        <search-free-filter-bar v-model="filters" :rental-object="rentalObject"
          :sort.sync="sortDirection" :show-controls="searchState !== 'idle'"
          @reset="resetFilters">
          <vc-date-picker ref="calendar" is-range v-model="range" mode="dateTime" :model-config="calendarConfig"
            :attributes="calendar_attributes" is24hr :input-debounce="500" title-position="left"
            :columns="$screens({ default: 1, lg: 2 })" :locale="$i18n.locale"
            :min-date="new Date()" :is-dark="$vuetify.theme.dark">
            <template v-slot="{ inputValue, inputEvents, togglePopover }">
              <!-- Тот же вид, что у полей командной шапки парка: outlined + dense,
                   иконка внутри рамки. Раньше поле было подчёркнутым, а календарь
                   висел слева от него — на общей строке это выбивалось. -->
              <v-text-field @click="togglePopover()" v-on="inputEvents"
                :value="dateRangeText(inputValue)" :label="$t('custom.start_end_dates')"
                prepend-inner-icon="mdi-calendar-clock" readonly hide-details dense outlined
                data-testid="search-free-dates"></v-text-field>
            </template>
          </vc-date-picker>
        </search-free-filter-bar>

        <!-- Пока не искали — не таблица с «отсутствуют данные», а приглашение.
             Даты выставляются только пикером или пресетом: клавиатурный ввод
             в проекте запрещён (решение USER). -->
        <v-flex v-if="searchState === 'idle'" class="text-center py-8">
          <v-icon size="56" color="grey lighten-1">mdi-calendar-search</v-icon>
          <h3 class="mt-4">{{ $t("custom.search_free_prompt") }}</h3>
          <p class="grey--text mt-1 mb-4">{{ $t("custom.search_free_hint") }}</p>
          <div class="d-flex flex-wrap justify-center" style="gap: 8px">
            <v-chip small label outlined @click="applyDatePreset('today')">
              {{ $t("custom.preset_today") }}
            </v-chip>
            <v-chip small label outlined @click="applyDatePreset('tomorrow')">
              {{ $t("custom.preset_tomorrow") }}
            </v-chip>
            <v-chip small label outlined @click="applyDatePreset('week')">
              {{ $t("custom.preset_week") }}
            </v-chip>
            <v-chip v-if="lastSearch" small label outlined color="primary"
              @click="applyLastSearch()">
              <v-icon left x-small>mdi-history</v-icon>{{ $t("custom.search_free_last") }}
            </v-chip>
          </div>
        </v-flex>

        <v-flex v-if="searchState !== 'idle'">
          <v-data-table :headers="headers" :items="cars"
            :loading="isLoading" :loading-text="$t('custom.loading_table')"
            :server-items-length.sync="total" :options.sync="tableOptions" :page.sync="page" item-key="id"
            :class="!isMobile ? 'mt-2 start-tour-bookings-1' : 'mt-2 start-tour-bookings-1 is-mobile'"
            :hide-default-header="isMobile"
            mobile-breakpoint="100" dense :footer-props="tableFooterProps([25, 50, 100], `{0} ${$t('custom.of')} ${total}`)">
            <template slot="item" slot-scope="props">
              <!-- На телефоне девять колонок уезжают за экран горизонтальным скроллом,
                   а «Итого» — то, ради чего сюда пришли, — оказывается вне поля зрения.
                   Поэтому строка вырождается в одну ячейку с карточкой; футер, загрузка
                   и пагинация остаются штатными, потому что таблица та же. -->
              <tr v-if="isMobile">
                <td :colspan="headers.length" class="pa-0" style="border-bottom: none; height: auto">
                  <search-free-car-card :car="props.item" :currency="displayCurrency"
                    :hours-price="calculateForHours(props.item)" :show-location="isInternal"
                    :can-book="!isPartner && !isGuest" @book="replaceToNewBooking" />
                </td>
              </tr>
              <tr v-else @dblclick="replaceToNewBooking(props.item)" style="cursor: pointer">
                <td nowrap class="text-left">
                  <v-flex class="d-flex align-middle">
                    <span class="block my-auto">
                      <span class="success--text title">{{ props.item.code }}</span>
                    </span>
                  </v-flex>
                </td>
                <td nowrap class="text-left">
                  <span class="">
                    <span class="caption" style="text-decoration: none !important;" :title="props.item.number">
                      {{ props.item.car_name }}
                    </span>
                    <br>
                    <span class="info--text caption">{{ props.item.number }}</span>
                  </span>
                </td>
                <!-- Три денежных чипа лежали в ОДНОЙ ячейке. Пока заголовков не было,
                     это ничему не мешало; с заголовками — три подписи над одной колонкой
                     сдвинули всё правое на две позиции. Теперь колонка на заголовок. -->
                <td nowrap class="text-center">
                  <v-chip :text-color="$vuetify.theme.dark ? 'white' : 'black'">
                    <v-avatar left>
                      <v-icon class="info--text">mdi-numeric-1-circle-outline</v-icon>
                    </v-avatar>
                    {{ props.item.selected_price }} {{ displayCurrency }}
                  </v-chip>
                </td>
                <td nowrap class="text-center">
                  <v-chip :text-color="$vuetify.theme.dark ? 'white' : 'black'">
                    <v-avatar left>
                      <v-icon class="warning--text">mdi-diameter-outline</v-icon>
                    </v-avatar>
                    {{ props.item.total }} {{ displayCurrency }}
                  </v-chip>
                </td>
                <!-- Условие ячейки — то же самое extraHours, что и у заголовка, а не
                     построчное: заголовок и ячейка обязаны появляться вместе. -->
                <td v-if="extraHours > 0" nowrap class="text-center">
                  <v-chip :text-color="$vuetify.theme.dark ? 'white' : 'black'">
                    <v-avatar left class="secondary--text" size="24">
                      <v-icon small>mdi-clock-time-eight-outline</v-icon>
                    </v-avatar>
                    {{ calculateForHours(props.item) }} {{ displayCurrency }}
                  </v-chip>
                </td>
                <td nowrap class="text-center">
                  <v-chip :text-color="$vuetify.theme.dark ? 'white' : 'black'">
                    <v-avatar left>
                      <v-icon class="success--text">mdi-cash-refund</v-icon>
                    </v-avatar>
                    {{ props.item.deposit }} {{ displayCurrency }}
                  </v-chip>
                </td>
                <!-- Четыре признака состояния машины на выдачу. Раньше здесь стояли
                     двенадцать v-icon с директивой v-tooltip, из них шесть — ветками
                     v-if по номеру состояния. Иконка, цвет и подпись переехали в
                     carConditionMeta, общий с мобильной карточкой. -->
                <td class="text-center">
                  <car-condition-icon :meta="transmissionMeta(props.item.automatic)" />
                </td>
                <td class="text-center">
                  <car-condition-icon :meta="stateMeta(props.item.state)" />
                </td>
                <td class="text-center">
                  <car-condition-icon :meta="cleanMeta(props.item.clean_state)" />
                </td>
                <td class="text-center">
                  <car-condition-icon :meta="tankMeta(props.item.tank_state)" />
                </td>
                <td v-if="isInternal">
                  {{ props.item.store_place }}
                </td>
                <td class="text-center">
                  <v-btn icon @click="replaceToNewBooking(props.item)"
                    :disabled="isPartner || isGuest">
                    <v-icon color="pink">
                      mdi-plus-circle
                    </v-icon>
                  </v-btn>
                </td>
              </tr>
            </template>
            <template slot="no-data">
              <div class="py-6 text-center">
                <v-icon size="40" color="grey lighten-1">mdi-car-off</v-icon>
                <p class="mt-2 mb-0">{{ $t("custom.search_free_none") }}</p>
              </div>
            </template>
          </v-data-table>
        </v-flex>
      </v-card-text>
    </v-card>
    <v-card v-else>
      <p>{{ $t("bookings.warn_balance") }}</p>
    </v-card>
  </span>
</template>
<script>
import moment from "moment";
import { setMomentLocale } from "@/utils/localeInfra";
import "moment/locale/ru";
import "moment/locale/en-gb";
import SearchFreeCarCard from "@/components/dashboard/bookings/SearchFreeCarCard.vue";
import CarConditionIcon from "@/components/dashboard/bookings/CarConditionIcon.vue";
import { stateMeta, transmissionMeta, cleanMeta, tankMeta } from "@/components/dashboard/bookings/carConditionMeta";
import SearchFreeFilterBar from "@/components/dashboard/bookings/SearchFreeFilterBar.vue";
import { defaultSearchFreeFilters, searchFreeFilterParams, noStatesSelected } from "@/components/dashboard/bookings/searchFreeFilters";
export default {
  name: "SearchFree",
  data() {
    return {
      cars: [],
      rental_days: 1,
      start_date: null,
      end_date: null,
      range: null,
      loadingInProgress: false,
      tableOptions: {},
      page: 1,
      per_page: 25,
      total: 0,
      calendarConfig: {
        type: "string",
        mask: "DD-MM-YYYY H:mm", // Uses 'iso' if missing,
        // timeAdjust: "10:00:00",
        minDate: moment().toISOString(),
      },
      calendar_attributes: [
        {
          key: "today",
          highlight: {
            color: "blue",
            fillMode: "outline",
            contentClass: "italic",
          },
          dates: new Date(),
        },
      ],
      showDaysSize: false,
      hasSearched: false,
      lastSearch: null,
      filters: defaultSearchFreeFilters(),
      sortDirection: "asc",
      isMobile: false,
      isLoading: false,
    };
  },
  created() {
    try {
      const saved = JSON.parse(localStorage.getItem("search_free_last") || "null");
      if (saved && saved.start && saved.end) this.lastSearch = saved;
    } catch (e) {
      this.lastSearch = null;
    }
    // moment Locale
    setMomentLocale(this.$i18n.locale);
    if (!this.$store.getters.isLoggedIn) {
      this.$store.commit("unsetCurrentUser");
    }
    // Вход из CRM (как на /booking/new): необязательные параметры start_date/end_date
    // приходят строками datetime-local ("YYYY-MM-DDTHH:mm"). Переводим их в маску
    // календаря ("DD-MM-YYYY H:mm") и кладём в range — watcher сам выставит
    // start_date/end_date и запустит loadFreeCars(). Без параметров страница
    // ведёт себя как раньше.
    let url = new URL(window.location.href);
    let crm_start_date = url.searchParams.get("start_date");
    let crm_end_date = url.searchParams.get("end_date");
    if (crm_start_date && crm_end_date) {
      let parsed_start = moment(crm_start_date, "YYYY-MM-DDTHH:mm");
      let parsed_end = moment(crm_end_date, "YYYY-MM-DDTHH:mm");
      if (parsed_start.isValid() && parsed_end.isValid()) {
        this.range = {
          start: parsed_start.format("DD-MM-YYYY HH:mm"),
          end: parsed_end.format("DD-MM-YYYY HH:mm"),
        };
      }
    }
  },
  watch: {
    tableOptions(pagination) {
      this.page = pagination.page;
      this.per_page = pagination.itemsPerPage > 0 ? pagination.itemsPerPage : 10;

      if (this.start_date && this.end_date) {
        this.loadFreeCars();
      }
    },
    range(newVal) {
      if (newVal) {
        if (newVal.start) {
          this.start_date = moment(newVal.start, "DD-MM-YYYY H:mm").format("DD-MM-YYYY H:mm");
        }
        if (newVal.end) {
          this.end_date = moment(newVal.end, "DD-MM-YYYY H:mm").format("DD-MM-YYYY H:mm");
        }

        if (newVal.start && newVal.end) {
          this.loadFreeCars();
        }
      } else {
        this.start_date = null;
        this.end_date = null;
        this.cars = [];
        this.hasSearched = false;
      }
    },
    sortDirection() {
      this.page = 1;
      if (this.start_date && this.end_date) {
        this.loadFreeCars();
      }
    },
    filters: {
      deep: true,
      handler() {
        // Новый набор фильтров — всегда с первой страницы: остаться на пятой странице
        // прежней выдачи значит показать пустоту там, где результаты есть.
        this.page = 1;
        if (this.start_date && this.end_date) {
          this.loadFreeCars();
        }
      },
    },
  },
  computed: {
    rentalObject() {
      const company = this.$store.getters.getCompany && this.$store.getters.getCompany.company;
      return (company && company.rental_object) || "cars";
    },
    // Заголовков не было с первого коммита (455408a2, 2023): девять колонок без единой
    // подписи, включая три безымянных денежных чипа подряд. Ключи — существующие,
    // новых в 15 локалей не заводим. sortable: false — сортировка серверная и её здесь нет.
    //
    // ИНВАРИАНТ: порядок и число элементов обязаны совпадать с <td> строки в шаблоне,
    // включая обе условные колонки (доп. часы, место хранения). Разъезд не виден ни
    // юнитам, ни линту — только глазами на странице.
    headers() {
      const columns = [
        { text: this.$t("custom.code"), value: "code", sortable: false },
        { text: this.$t("cars.name"), value: "car_name", sortable: false },
        { text: this.$t("bookings.day_price"), value: "selected_price", sortable: false, align: "center" },
        { text: this.$t("bookings.total"), value: "total", sortable: false, align: "center" },
      ];
      if (this.extraHours > 0) {
        columns.push({ text: this.$t("bookings.hours_cost"), value: "hours_cost", sortable: false, align: "center" });
      }
      columns.push(
        { text: this.$t("bookings.deposit"), value: "deposit", sortable: false, align: "center" },
        { text: this.$t("cars.gear_big"), value: "automatic", sortable: false, align: "center" },
        { text: this.$t("custom.state"), value: "state", sortable: false, align: "center" },
        { text: this.$t("bookings.clean"), value: "clean_state", sortable: false, align: "center" },
        { text: this.$t("bookings.gas"), value: "tank_state", sortable: false, align: "center" }
      );
      if (this.isInternal) {
        columns.push({ text: this.$t("home.location"), value: "store_place", sortable: false });
      }
      columns.push({ text: this.$t("custom.actions"), value: "actions", sortable: false, align: "center" });
      return columns;
    },
    // Три состояния страницы, а не два: «ещё не искали» — это не «данных нет».
    // Прежний шаблон показывал «Отсутствуют данные» до первого запроса, то есть
    // отчитывался об отказе в ответ на вопрос, которого никто не задавал.
    // Неполные сутки сверх целых — общее свойство окна поиска, а не строки: часы
    // одни и те же для всех машин, различается только цена часа. Отсюда и колонка.
    extraHours() {
      if (!this.start_date || !this.end_date) return 0;
      const start = moment.utc(this.start_date, "DD-MM-YYYY H:mm");
      const end = moment.utc(this.end_date, "DD-MM-YYYY H:mm");
      const fullHours = moment.duration(end.diff(start)).asHours();
      const hours = Math.trunc(fullHours % 24);
      const limit = this.company ? this.company.hours_limit : null;
      if (fullHours > 24 && hours > 0 && limit > 0 && hours < limit) return hours;
      return 0;
    },
    // Один и тот же тернарник стоял в шаблоне у каждого денежного чипа.
    displayCurrency() {
      if (this.company && this.company.multicurrency_cashboxes) {
        return this.findCurrencySymbol(this.base_currency_id) || "";
      }
      return this.currency;
    },
    searchState() {
      if (!this.hasSearched) return "idle";
      return this.cars.length > 0 ? "results" : "empty";
    },
    company() {
      return this.$store.getters.getCompany.company;
    },
    currency() {
      if (
        this.$store.getters.getCompany &&
        this.$store.getters.getCompany.company &&
        this.$store.getters.getCompany.company.currency
      ) {
        return this.$store.getters.getCompany.company.currency;
      } else {
        return "";
      }
    },
    active_company_cashboxes() {
      if (this.$store.getters.getCompany && this.$store.getters.getCompany.company && this.$store.getters.getCompany.company.company_cashboxes) {
        let cashboxes = [];
        this.$store.getters.getCompany.company.company_cashboxes.forEach((cashbox) => {
          if (cashbox.id && cashbox.is_active) {
            cashboxes.push(cashbox);
          }
        });
        cashboxes.sort((a, b) => {
          // сортировка по is_default
          if (a.is_default && !b.is_default) {
            return -1;
          }
        });
        return cashboxes;
      } else {
        return [];
      }
    },
    currencies() {
      if (
        this.$store.getters.getCompany &&
        this.$store.getters.getCompany.company &&
        this.$store.getters.getCompany.company.currencies
      ) {
        return this.$store.getters.getCompany.company.currencies;
      } else {
        return [];
      }
    },
    base_currency_id() {
      if (this.active_company_cashboxes && this.active_company_cashboxes.length > 0) {
        return this.active_company_cashboxes.find((cashbox) => cashbox.is_default).currency_id;
      } else {
        return null;
      }
    },
  },
  methods: {
    // Пресеты дат — тот же паттерн и те же i18n-ключи, что в BookingsFilterPanel.
    // Возвращают маску календаря "DD-MM-YYYY HH:mm"; watcher на range сам запустит поиск.
    applyDatePreset(kind) {
      const start = moment();
      let end;
      if (kind === "today") {
        end = moment().add(1, "day");
      } else if (kind === "tomorrow") {
        start.add(1, "day");
        end = moment().add(2, "day");
      } else {
        end = moment().add(7, "day");
      }
      this.range = {
        start: start.format("DD-MM-YYYY HH:mm"),
        end: end.format("DD-MM-YYYY HH:mm"),
      };
    },
    stateMeta,
    transmissionMeta,
    cleanMeta,
    tankMeta,
    // Подпись поля дат. Раньше склеивалась тернарниками прямо в шаблоне: три вложенных
    // условия ради одного дефиса между началом и концом.
    dateRangeText(inputValue) {
      const from = (inputValue && inputValue.start) || "";
      const to = (inputValue && inputValue.end) || "";
      if (from && to) return `${from} - ${to}`;
      return from || to || "";
    },
    resetFilters() {
      this.filters = defaultSearchFreeFilters();
      this.sortDirection = "asc";
    },
    applyLastSearch() {
      if (this.lastSearch) {
        this.range = { start: this.lastSearch.start, end: this.lastSearch.end };
      }
    },
    rememberSearch() {
      try {
        localStorage.setItem(
          "search_free_last",
          JSON.stringify({ start: this.start_date, end: this.end_date })
        );
      } catch (e) {
        // приватный режим — молча обходимся без «последнего поиска»
      }
    },
    loadFreeCars() {
      if (this.loadingInProgress) {
        return;
      }

      this.showDaysSize = false;
      // Снятые все состояния — «ничего не показывать». Сервер так не умеет: пустой
      // state он трактует как отсутствие фильтра и вернул бы все четыре, то есть
      // выдача противоречила бы снятым галкам. Поэтому случай закрыт на фронте.
      if (noStatesSelected(this.filters)) {
        this.cars = [];
        this.total = 0;
        this.hasSearched = true;
        return;
      }
      if (this.start_date && this.end_date && !moment(this.start_date, "DD-MM-YYYY H:mm").isAfter(moment(this.end_date, "DD-MM-YYYY H:mm"))) {
        this.loadingInProgress = true;
        this.isLoading = true;

        this.axios
          .post(`/api/v1/free_cars_for_rent_v2`,
            {
              start_date: this.start_date,
              end_date: this.end_date,
              page: this.page,
              per_page: this.per_page,
              ...searchFreeFilterParams(this.filters),
              sort_by: "average_price",
              direction: this.sortDirection,
            },
            {
              headers: {
                Authorization: this.$store.getters.getAuthToken
              }
            }
          )
          .then((response) => {
            this.cars = [];
            response.data.cars.data.forEach((car) => {
              this.cars.push(car.attributes);
            });
            this.hasSearched = true;
            this.rememberSearch();
            this.total = response.data.total_count;
            this.rental_days = response.data.rental_days;
            this.showDaysSize = true;
          })
          .catch((error) => {
            this.isLoading = false;
            this.setError(error, this.$t("errors.error"));
          })
          .finally(() => {
            this.isLoading = false;
            this.loadingInProgress = false;
          });
      } else {
        this.$notify(this.$t("errors.error"), this.$t("errors.incorrect_date_text"), "error", 3000);
      }
    },
    calculateDaysSize() {
      if (this.start_date && this.end_date && this.cars.length > 0 && this.cars[0].selected_price > 0) {
        // let days = this.cars[0].total / this.cars[0].selected_price;
        let days = this.rental_days;
        let full_hours = moment.duration(moment(this.end_date, "DD-MM-YYYY H:mm").diff(moment(this.start_date, "DD-MM-YYYY H:mm"))).asHours();
        let hours = Math.trunc(full_hours % 24);
        if (hours > 0 && full_hours > 24 && this.company.hours_limit && this.company.hours_limit > 0 && hours < this.company.hours_limit) {
          return `${days} ${this.$tc("bookings.days_plural", days)} ${hours} ${this.$tc("custom.add_hours_plural", hours)}`;
        } else {
          return `${days} ${this.$tc("bookings.days_plural", days)}`;
        }
      } else {
        return "?";
      }
    },
    calculateForHours(car) {
      return this.extraHours * ((car && car.price_hour) || 0);
    },
    findCurrencySymbol(id) {
      if (id != null) {
        if (this.currencies.find((currency) => currency.id == id)) {
          return this.currencies.find((currency) => currency.id == id).symbol;
        }
      }
    },
    replaceToNewBooking(car) {
      if (!this.isPartner) {
        // Флоу из CRM (как pickCar в CrmLeadConvertWorkspace): переносим в NewBooking
        // текущие даты поиска и входные lead_id/client_id, чтобы конвертация лида
        // не обрывалась на выборе машины. NewBooking ждёт даты в "YYYY-MM-DDTHH:mm".
        const query = { car_id: car.id };
        if (this.start_date && this.end_date) {
          query.start_date = moment(this.start_date, "DD-MM-YYYY H:mm").format("YYYY-MM-DDTHH:mm");
          query.end_date = moment(this.end_date, "DD-MM-YYYY H:mm").format("YYYY-MM-DDTHH:mm");
        }
        let url = new URL(window.location.href);
        let lead_id = url.searchParams.get("lead_id");
        let client_id = url.searchParams.get("client_id");
        if (lead_id) {
          query.lead_id = lead_id;
        }
        if (client_id) {
          query.client_id = client_id;
        }
        this.$router.push({ path: "/booking/new", query: query });
      }
    },
    checkMobile() {
      if (this.$vuetify.breakpoint.name == "xs" || this.$vuetify.breakpoint.name == "sm") {
        this.isMobile = true;
        return true;
      } else {
        this.isMobile = false;
        return false;
      }
    },
  },
  components: {
    SearchFreeCarCard,
    SearchFreeFilterBar,
    CarConditionIcon,
  },
};
</script>
